import { FormControl, TextInputWithTokens, Autocomplete, Select, Textarea, Checkbox, CheckboxGroup, Radio, RadioGroup, Text } from '@primer/react';
import { MarkGithubIcon } from '@primer/octicons-react';
import * as React from 'react';
export default {
  FormControl,
  TextInputWithTokens,
  Autocomplete,
  Select,
  Textarea,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Text,
  MarkGithubIcon,
  React
};